import { z } from 'zod';
import * as v from './common';
import { passwordIsValid } from './password';

const SignupBase = z.object({
  fullName: v.fullName,
  email: v.email,
  password: passwordIsValid,
  invite: z.string().optional(),
});

const phoneFields = v.phoneField({
  countryFieldName: 'countryCode',
  phoneFieldName: 'phoneNumber',
});

export const Signup = SignupBase;

export const CompleteSignup = SignupBase.pick({}).and(phoneFields);

export const LoginSchema = z.object({
  email: v.email,
  password: passwordIsValid,
});

export type ICompleteSignup = z.infer<typeof CompleteSignup>;
